import { useCallback } from 'react';
import * as React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { useTranslation } from 'react-i18next';

import { MenuItem, OverflowMenu, UserIcon, spacing } from '@pletly/ui';
import { useToggle } from '@pletly/common';
import { HamburgerIcon } from '%components/icons/Hamburger';
import DeleteIcon from '%assets/icons/trash.svg';
import { Member } from '../GroupMember';

interface Props {
	name: string;
	photoUrl?: string | null;
	admin?: boolean;
	onSetAs?: () => unknown;
	onDelete?: () => unknown;
	accessoryRight?: React.ReactNode;
}

export const MemberRow = ({ name, photoUrl, admin, onSetAs, onDelete, accessoryRight }: Props) => {
	const { t } = useTranslation();
	const [isMenuOpened, toggleMenu] = useToggle();

	const handleMenuItemPress = useCallback(
		(pressHandler?: () => unknown) => () => {
			toggleMenu();
			pressHandler?.();
		},
		[toggleMenu],
	);

	return (
		<Member
			name={name}
			photoUrl={photoUrl}
			accessoryRight={
				accessoryRight ? (
					accessoryRight
				) : (
					<OverflowMenu
						anchor={() => (
							<TouchableOpacity onPress={toggleMenu}>
								<HamburgerIcon />
							</TouchableOpacity>
						)}
						visible={isMenuOpened}
						onBackdropPress={toggleMenu}
					>
						<MenuItem
							accessoryLeft={<UserIcon />}
							title={`Set as ${admin ? 'member' : 'admin'}`}
							style={styles.menuItem}
							onPress={handleMenuItemPress(onSetAs)}
						/>
						<MenuItem
							accessoryLeft={<DeleteIcon />}
							title={t('common.delete')}
							status="danger"
							style={styles.menuItem}
							onPress={handleMenuItemPress(onDelete)}
						/>
					</OverflowMenu>
				)
			}
		/>
	);
};

const styles = StyleSheet.create({
	menuItem: { justifyContent: 'flex-start', marginLeft: spacing(0.5) },
});
